import React, { Component } from 'react'
import Modal from 'react-modal';
import { connectModal } from 'redux-modal'
import { ACTION_DIALOG } from '../../../constants'

class ActionCompleteDialog extends Component {

    constructor () {
        super();

        this.handleCancel = this.handleCancel.bind(this);
    }

    handleCancel () {
        if(this.props.closeCallback){
            this.props.closeCallback();
        }
        this.props.handleHide();
    }


    render() {
        const { show, message, cancelLbl } = this.props;

        return (
            <Modal
                isOpen={show}
                overlayClassName="dialog__overlay"
                className="dialog__content"
                onRequestClose={this.handleCancel}
                role="dialog"
                ariaHideApp={true}
                contentLabel={message}
            >
                <div className="dialog--action-complete">
                    <div className="dialog__message">{message}</div>
                    <button className="dialog__btn dialog__btn--close" onClick={this.handleCancel}
                            aria-label={cancelLbl}>X</button>
                </div>
            </Modal>
        );
    }
}

export default connectModal({ name: ACTION_DIALOG, destroyOnHide: true })(ActionCompleteDialog)